export interface GenericTableData<T> {
  items: T[];
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  totalItemsCount: number;
  totalFiltersActivatedCount: number;
}
